import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinStateBridgeOpenweather',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    bridgeConfig: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    }
  },
  data: function () {
    return {
      deviceIdentifier: null,
      parsedPacketVariable: null,
      selectedWeatherVariable: [],
      variableTableHeader: [{
        sortable: true,
        text: 'Name',
        value: 'variable',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('Common.description'),
        value: 'description',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'value_type_name',
        align: 'left'
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    formIsValid() {
      return !isNullOrEmpty(this.deviceIdentifier);
    },
    weatherVariables() {
      let _variables = [{
        variable: 'cur_temperature',
        keyName: 'current',
        descrKey: 'temperature',
        unit: '°C'
      }, {
        variable: 'cur_temperature_feels_like',
        keyName: 'current',
        descrKey: 'temperature_feels_like',
        unit: '°C'
      }, {
        variable: 'cur_pressure',
        keyName: 'current',
        descrKey: 'pressure',
        unit: 'hPa'
      }, {
        variable: 'cur_humidity',
        keyName: 'current',
        descrKey: 'humidity',
        unit: '%'
      }, {
        variable: 'cur_wind_speed',
        keyName: 'current',
        descrKey: 'wind_speed',
        unit: ''
      }, {
        variable: 'cur_wind_direction',
        keyName: 'current',
        descrKey: 'wind_direction',
        unit: '°'
      }, {
        variable: 'cur_uv_index',
        keyName: 'current',
        descrKey: 'uv_index',
        unit: ''
      }, {
        variable: 'cur_clouds_pct',
        keyName: 'current',
        descrKey: 'clouds_pct',
        unit: '%'
      }];
      for (let day = 0; day < 7; day++) {
        const keyName = day === 0 ? 'today' : `plus_${day}`;
        _variables = _variables.concat([{
          variable: `${keyName}_temp_day`,
          keyName,
          descrKey: 'temperature_day',
          unit: '°C'
        }, {
          variable: `${keyName}_temp_night`,
          keyName,
          descrKey: 'temperature_night',
          unit: '°C'
        }, {
          variable: `${keyName}_temp_min`,
          keyName,
          descrKey: 'temperature_min',
          unit: '°C'
        }, {
          variable: `${keyName}_temp_max`,
          keyName,
          descrKey: 'temperature_max',
          unit: '°C'
        }, {
          variable: `${keyName}_pressure`,
          keyName,
          descrKey: 'pressure',
          unit: 'hPa'
        }, {
          variable: `${keyName}_humidity`,
          keyName,
          descrKey: 'humidity',
          unit: '%'
        }, {
          variable: `${keyName}_wind_speed`,
          keyName,
          descrKey: 'wind_speed',
          unit: ''
        }, {
          variable: `${keyName}_wind_direction`,
          keyName,
          descrKey: 'wind_direction',
          unit: '°'
        }, {
          variable: `${keyName}_rain_mm`,
          keyName,
          descrKey: 'rain_mm',
          unit: 'mm'
        }, {
          variable: `${keyName}_uv_index`,
          keyName,
          descrKey: 'uv_index',
          unit: ''
        }, {
          variable: `${keyName}_clouds_pct`,
          keyName,
          descrKey: 'clouds_pct',
          unit: '%'
        }]);
      }
      return _variables.map(wVar => {
        const day = this.$i18n_t(`Bridges.Openweather.${wVar.keyName}`);
        const desc = this.$i18n_t(`Bridges.Openweather.${wVar.descrKey}`);
        return {
          variable: wVar.variable,
          description: `${day} - ${desc}`,
          value_type_name: wVar.unit
        };
      });
    }
  },
  watch: {
    parsedPacketVariable() {
      this.emitSelection();
    },
    deviceIdentifier() {
      this.emitSelection();
    }
  },
  created() {
    if (this.bridgeConfig.stationId) {
      this.deviceIdentifier = this.bridgeConfig.stationId;
    } else {
      this.deviceIdentifier = this.bridgeConfig.configId;
    }
    this.selectedWeatherVariable = [{
      variable: this.lclModel.properties.binding.options.variable
    }];
  },
  methods: {
    emitSelection() {
      this.$emit('bridge-binding-changed', {
        valueType: get(this.selectedWeatherVariable, '[0].value_type_name'),
        variable: get(this.selectedWeatherVariable, '[0].variable')
      });
    },
    saveState() {
      this.lclModel.properties.binding.options.identifier = this.deviceIdentifier;
      this.lclModel.properties.binding.options.variable = this.selectedWeatherVariable[0].variable;
    }
  }
};